export const FETCH_CANDIDATE_PROFILE = "FETCH_CANDIDATE_PROFILE";
export const FETCH_CANDIDATE_APPLICATIONS = "FETCH_CANDIDATE_APPLICATIONS";

export const CANDIDATES_INITIAL_STATE = {
  candidateProfile: null,
  applications: [],
};
